import type { InteractionState } from '../types.js';

export function reducePanDomain<T extends InteractionState>(
  domain: T['currentDomain'],
) {
  return (prev: T): T => ({
    ...prev,
    currentDomain: domain,
    explore: { visible: false, pinned: false },
    highlightedSeriesId: undefined,
    select: undefined,
  });
}
